import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';

import Header from '../Header';
import { getAppBarHeight } from '../util/helpers';
import appTheme from '../styles/themes/theme';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { ChildMerchantParentRouteGuard } from './ChildMerchantParentRouteGuard';

const MainLayout = (): JSX.Element => {
  useDocumentTitle();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <CssBaseline />
      <Header />
      <ChildMerchantParentRouteGuard />
      <Box
        sx={{
          flexGrow: 1,
          height: `calc(100% - ${getAppBarHeight()}px)`,
          [appTheme.breakpoints.down('md')]: {
            height: `calc(100% - ${getAppBarHeight(true)}px)`,
          },
          overflow: 'auto',
          display: 'flex',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
